import { validate_user_role } from '../utils/validate'
import { baseService } from './baseService'
import { LOGIN_UNAUTHORIZED, STATUS_CODE } from '../data/system_settings'
import Response from '../data/entity/response_entity'
import verify_jwt from '../utils/verify_jwt'

export class LoginService extends baseService {
  async login({ email, password }) {
    try {
      const res = await this.postPublic('auth/login', { email, password })
      return await handleLoginResponse(res)
    } catch (error) {
      error.type = 'login'
      return handleError(error)
    }
  }

  async login365({ code, redirectUri }) {
    try {
      const res = await this.getPublic('auth/login-365', {
        code,
        'redirect-uri': redirectUri,
      })
      return await handleLoginResponse(res)
    } catch (error) {
      error.type = 'login365'
      return handleError(error)
    }
  }
}
const handleLoginResponse = async (res) => {
  if (res.status === STATUS_CODE.SUCCESS) {
    const { accessToken, publicKey } = res.data.data
    if (!accessToken) {
      throw new Error('Không tìm thấy mã truy cập vui lòng liên hệ admin')
    }
    const decodedToken = await verify_jwt({
      token: accessToken,
      publicKey: publicKey,
    })
    if (!decodedToken) {
      throw new Error('Quá trình xác thực thất bại. Vui lòng thử lại')
    }

    const { email, groups, uuid } = decodedToken
    // if (!validate_user_role(groups)) {
    //   return Response({
    //     success: false,
    //     message: { content: LOGIN_UNAUTHORIZED },
    //   })
    // }
    return Response({
      success: true,
      message: { content: { accessToken, email, publicKey, uuid } },
    })
  }

  throw new Error('Vui lòng liên hệ admin')
}
const handleError = (error) => {
  let message = error.message
  switch (error.status) {
    case STATUS_CODE.BAD_REQUEST:
      message =
        error.type === 'login365'
          ? 'Quá trình xác thực thất bại. Vui lòng thử lại'
          : 'Sai thông tin đăng nhập'
      break
    case STATUS_CODE.ECONNABORTED:
      message = 'Lỗi kết nối mạng, vui lòng thử lại sau'
      break
    case STATUS_CODE.NOT_FOUND:
      message =
        error.type === 'login365'
          ? 'Quá trình xác thực thất bại. Vui lòng thử lại'
          : 'Sai thông tin đăng nhập'
      break
    default:
      message = message ? message : 'Lỗi không xác định'
      break
  }

  return Response({ success: false, message: { content: message } })
}
const LoginServicer = new LoginService()
export default LoginServicer
